import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/home/home.component').then((m) => m.HomeComponent),
    title: 'Viajes Demo | Viaja, descubre y disfruta',
  },
  {
    path: 'servicios',
    loadComponent: () =>
      import('./features/servicios/servicios.component').then(
        (m) => m.ServiciosComponent,
      ),
    title: 'Servicios | Viajes Demo',
  },
  {
    path: 'experiencias',
    loadComponent: () =>
      import('./features/experiencias/experiencias.component').then(
        (m) => m.ExperienciasComponent,
      ),
    title: 'Experiencias | Viajes Demo',
  },
  {
    path: 'nosotros',
    loadComponent: () =>
      import('./features/nosotros/nosotros.component').then(
        (m) => m.NosotrosComponent,
      ),
    title: 'Nosotros | Viajes Demo',
  },
  {
    path: 'contacto',
    loadComponent: () =>
      import('./features/contacto/contacto.component').then(
        (m) => m.ContactoComponent,
      ),
    title: 'Contacto | Viajes Demo',
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
    title: 'Página no encontrada | Viajes Demo',
  },
];
